export type ProductMode = 'vibe-code' | 'white-label';

function resolveProductMode(): ProductMode {
  const rawMode = import.meta.env.VITE_PRODUCT_MODE?.toLowerCase();
  if (rawMode === 'white-label') {
    return 'white-label';
  }
  return 'vibe-code';
}

export const PRODUCT_MODE: ProductMode = resolveProductMode();
export const IS_WHITE_LABEL_PRODUCT = PRODUCT_MODE === 'white-label';

/**
 * Marca fixada no build (`VITE_BRAND=globall`). Quando presente, a identidade é
 * propriedade do DEPLOY e não do aparelho — o sandbox de branding por
 * localStorage fica desligado. Ausente = comportamento de sempre.
 */
export const FIXED_BRAND_ID: string | undefined =
  import.meta.env.VITE_BRAND?.toLowerCase().trim() || undefined;
